import {
  faCcAmex,
  faCcJcb,
  faCcMastercard,
  faCcVisa,
  faCcDiscover,
  faCcDinersClub,
} from '@fortawesome/free-brands-svg-icons';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Brand({ type, ...props }) {
  if (type.toLowerCase() === 'visa')
    return <FontAwesomeIcon size="2x" icon={faCcVisa} {...props} width={32} />;
  if (type.toLowerCase() === 'mastercard')
    return <FontAwesomeIcon size="2x" icon={faCcMastercard} width={32} />;
  if (type.toLowerCase() === 'jcb')
    return <FontAwesomeIcon size="2x" icon={faCcJcb} width={32} />;
  if (type.toLowerCase() === 'amex')
    return <FontAwesomeIcon size="2x" icon={faCcAmex} width={32} />;
  if (type.toLowerCase() === 'discover')
    return <FontAwesomeIcon size="2x" icon={faCcDiscover} width={32} />;
  if (type.toLowerCase() === 'diners')
    return <FontAwesomeIcon size="2x" icon={faCcDinersClub} width={32} />;
  return <FontAwesomeIcon size="2x" icon={faCreditCard} width={32} />;
}

export default Brand;
